import { render, staticRenderFns } from "./ShutdownAlert.vue?vue&type=template&id=4afb985c&scoped=true"
import script from "./ShutdownAlert.vue?vue&type=script&lang=js"
export * from "./ShutdownAlert.vue?vue&type=script&lang=js"
import style0 from "./ShutdownAlert.vue?vue&type=style&index=0&id=4afb985c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afb985c",
  null
  
)

export default component.exports